<div style="max-width: 1020px">
    <ngx-datatable
        [columnMode]="ColumnMode.force"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="50"
        [scrollbarV]="true"
        [scrollbarH]="true"
        [rows]="rows"
    >
            <ngx-datatable-column name="Name" [width]="300" [frozenLeft]="true"> </ngx-datatable-column>
            <ngx-datatable-column name="Gender"> </ngx-datatable-column>
            <ngx-datatable-column name="Age"> </ngx-datatable-column>
            <ngx-datatable-column name="City" [width]="150" prop="address.city"> </ngx-datatable-column>
            <ngx-datatable-column name="State" [width]="300" prop="address.state" [frozenRight]="true">
        </ngx-datatable-column>
    </ngx-datatable>
</div>